export default __webpack_public_path__ + "static/media/users.57e5c3eb.svg";